<div *ngIf="ulp === 'false'">
  <div class="c-auth">
    <div class="c-auth__wrapper">
      <form class="c-auth__form" #f="ngForm" (ngSubmit)="login(f.value)">
        <div class="brand-container">
          <img
            src="assets/img/logos/lightspeed-symbol.svg"
            class="c-auth__brand c-auth__brand-logo"
            alt="Lightspeed"
          />
          <img
            src="assets/img/logos/lightspeed-horizontal.svg"
            class="c-auth__brand"
            alt="Lightspeed"
          />
        </div>
        <div>
          <p class="c-auth__text" i18n="Login|Welcome message @@welcomeMessage">
            Welcome to Lightspeed Restaurant POS (L-Series)
          </p>
        </div>
        <div *ngIf="error" class="error-msg">{{ error }}</div>
        <div class="c-form__item">
          <label for="username" i18n="Login|Label for username @@labelUsername"
            >Username</label
          >
          <input
            [(ngModel)]="username"
            id="username"
            name="username"
            tabindex="1"
            type="text"
            autocomplete="on"
            autofocus
            autocapitalize="off"
          />
        </div>
        <div class="c-form__item">
          <label class="label-dark" for="password">
            <span i18n="Login|Label for password field @@labelPassword"
              >Password</span
            >
            <a
              class="c-form-label__link"
              routerLink="/reset"
              href="#"
              title="Forgot your password?"
              i18n="Login|link for forgot your password @@linkForgetPassword"
              >Forgot your password?</a
            >
          </label>
          <input
            ngModel
            id="password"
            name="password"
            tabindex="2"
            type="password"
            autocomplete="on"
            #passwordInput
          />
        </div>
        <input
          [(ngModel)]="companyId"
          id="companyId"
          name="companyId"
          type="hidden"
        />
        <div class="c-form__button">
          <button
            type="submit"
            class="o-button o-button--success"
            tabindex="3"
            i18n="Login|Button for log in @@buttonLogIn"
          >
            Log in
          </button>
        </div>
      </form>
      <p class="c-auth__outro u-hidden-small">
        Need help? Visit our
        <a
          href="http://lightspeedhq.com/restaurant"
          target="_blank"
          title="Lightspeed Restaurant website"
          >website</a
        >.
      </p>
    </div>
  </div>
  <!-- Dynamic translations -->
  <div
    ls-dynamic-translation
    id="Invalid username or password"
    i18n="Login|Invalid username or password error message @@errorMessageInvalidLogin"
  >
    Invalid username or password
  </div>
</div>
